export const baseURL = "https://casino.adminvergelive.com/";
export const adminBaseURL = "https://admin.adminvergelive.com/";
export const key = "vlk_a7248276e0671d83072bb81d206430581b25e11f4e733b12";